export default __webpack_public_path__ + "static/media/icon_menu_buger_Close.de780e61.svg";